import _regeneratorRuntime from "@babel/runtime/regenerator";

var _this = this,
    _jsxFileName = "/Users/michaelschlecht/Documents-CCM/dev/ccm-innovation/pricing-components/src/components/PricingCalculatorClassic/PricingCalculatorClassic.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { Fragment, useEffect } from "react";
import { PropTypes } from "prop-types";
import NumberFormat from "react-number-format";
import "./PricingCalculatorClassic.scss";
import _ from 'lodash';
import * as SharedUtils from '../../utils/shared-utils';
import * as Utils from "../../utils/pricing-calculator-utils";
import { StatePicker } from '@ccm-innovation/address-components';

var PricingCalculatorClassic = function PricingCalculatorClassic(props) {
  var initialState = {
    // Inputs
    coverageID: '--Select--',
    birthday: null,
    maritalStatus: '--Select--',
    state: null,
    // Verification
    verified: {
      coverageID: null,
      birthday: null,
      maritalStatus: null,
      state: null
    },
    // // Inputs
    // coverageID: 1,
    // birthday: '11/11/2005',
    // maritalStatus: 'single',
    // state: 'WI',
    // // Verification
    // verified: {
    //   coverageID: true,
    //   birthday: true,
    //   maritalStatus: true,
    //   state: true,
    // },
    plansCanBeFetched: false,
    // Miscellaneous
    errorMessage: '',
    isFetchingPlans: false
  };
  /*******************************************/
  /// COVERAGE ID state + Validation effect ///

  /*******************************************/

  var _React$useState = React.useState(initialState.coverageID),
      coverageID = _React$useState[0],
      setCoverageID = _React$useState[1];

  useEffect(function () {
    debugMode && console.log('CoverageID changed:', coverageID);
    if (coverageID || verified.coverageID !== null) validateCoverageID();
  }, [coverageID]);
  /****************************************/
  /// BIRTHDAY state + Validation effect ///

  /****************************************/

  var _React$useState2 = React.useState(initialState.birthday),
      birthday = _React$useState2[0],
      setBirthday = _React$useState2[1];

  useEffect(function () {
    debugMode && console.log('Birthday changed:', birthday);
    if (birthday && (birthday.indexOf('_') === -1 || verified.birthday !== null)) validateBirthday();
  }, [birthday]);
  /**********************************************/
  /// MARITAL STATUS state + Validation effect ///

  /**********************************************/

  var _React$useState3 = React.useState(initialState.maritalStatus),
      maritalStatus = _React$useState3[0],
      setMaritalStatus = _React$useState3[1];

  useEffect(function () {
    debugMode && console.log('Marital Stats Changed:', maritalStatus);
    if (maritalStatus) validateMaritalStatus();
  }, [maritalStatus]);
  /***********************************/
  // STATE state + Validation effect //

  /***********************************/

  var _React$useState4 = React.useState(initialState.state),
      state = _React$useState4[0],
      setState = _React$useState4[1];

  useEffect(function () {
    debugMode && console.log('State Changed:', state);
    if (state || verified.state !== null) validateState();
  }, [state]);
  /************************************/
  /// VERIFIED state + Change Effect ///

  /************************************/

  var _React$useState5 = React.useState(initialState.verified),
      verified = _React$useState5[0],
      setVerified = _React$useState5[1];

  useEffect(function () {
    debugMode && console.log('Verified Changed:', verified);
    checkIfPlansCanBeFetched();
  }, [verified]);
  /********************************/
  /// PLANS CAN BE FETCHED state ///

  /********************************/

  var _React$useState6 = React.useState(initialState.plansCanBeFetched),
      plansCanBeFetched = _React$useState6[0],
      setPlansCanBeFetched = _React$useState6[1];
  /*************************/
  /// ERROR MESSAGE state ///

  /*************************/


  var _React$useState7 = React.useState(initialState.errorMessage),
      errorMessage = _React$useState7[0],
      setErrorMessage = _React$useState7[1];
  /*****************************/
  /// IS FETCHING PLANS state ///

  /*****************************/


  var _React$useState8 = React.useState(initialState.isFetchingPlans),
      isFetchingPlans = _React$useState8[0],
      setIsFetchingPlans = _React$useState8[1];
  /*********************/
  /// DEBUG MODE prop ///

  /*********************/


  var debugMode = props.debugMode;
  /***************************/
  /// COVERAGE ID functions ///

  /***************************/

  var updateCoverageID = function updateCoverageID(newCoverageID) {
    debugMode && console.log('Updating Coverage ID:', newCoverageID);
    setCoverageID(parseInt(newCoverageID) ? newCoverageID : null);
  };

  var validateCoverageID = function validateCoverageID() {
    var coverageIDValid = Utils.validateCoverageID(coverageID);
    debugMode && console.log('Coverage ID Valid?', coverageIDValid);
    setVerified(_extends({}, verified, {
      coverageID: coverageIDValid
    }));
  };
  /************************/
  /// BIRTHDAY functions ///

  /************************/


  var updateBirthday = function updateBirthday(newBirthday) {
    debugMode && console.log('Updating Birthday:', newBirthday);
    setBirthday(newBirthday);
  };

  var validateBirthday = function validateBirthday() {
    var birthdayValid = Utils.validateDate(birthday);
    debugMode && console.log('Birthday Valid?', birthdayValid);
    setVerified(_extends({}, verified, {
      birthday: birthdayValid
    }));
  };
  /******************************/
  /// MARITAL STATUS functions ///

  /******************************/


  var updateMaritalStatus = function updateMaritalStatus(newMaritalStatus) {
    debugMode && console.log('Updating Marital Status', newMaritalStatus);
    setMaritalStatus(newMaritalStatus);
  };

  var validateMaritalStatus = function validateMaritalStatus() {
    var maritalStatusValid = Utils.validateMaritalStatus(maritalStatus);
    debugMode && console.log("Marital Status Valid?", maritalStatusValid);
    setVerified(_extends({}, verified, {
      maritalStatus: maritalStatusValid
    }));
  };
  /*********************/
  /// STATE functions ///

  /*********************/


  var updateState = function updateState(newState) {
    debugMode && console.log('Updating State:', newState);
    setState(newState);
  };

  var validateState = function validateState() {
    var stateValid = Utils.validateState(state);
    debugMode && console.log("State Valid?", stateValid);
    setVerified(_extends({}, verified, {
      state: stateValid
    }));
  };
  /***************************/
  /// FETCH PRICES function ///

  /***************************/


  var handleFetchPrices = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      var muleApiUrl, muleClientId, muleClientSecret, muleConfig, planOptionsResponse;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              setIsFetchingPlans(true);
              props.onPlanOptionsRequested();
              muleApiUrl = props.muleApiUrl, muleClientId = props.muleClientId, muleClientSecret = props.muleClientSecret;
              muleConfig = {
                auth: {
                  username: muleClientId,
                  password: muleClientSecret
                },
                headers: {
                  "access-control-allow-origin": "*"
                }
              };
              _context.next = 7;
              return Utils.fetchPrices(muleApiUrl, muleConfig, SharedUtils.formatDate(birthday), coverageID, state, maritalStatus);

            case 7:
              planOptionsResponse = _context.sent;
              // If minor, replace HID values with 'N/A'
              if (Utils.getAge(birthday) < 18) handleMinor(planOptionsResponse);
              setIsFetchingPlans(false);
              props.onPlanOptionsFetched(planOptionsResponse);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleFetchPrices(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  /***************************/
  /// HANDLE MINOR function ///

  /***************************/


  var handleMinor = function handleMinor(planOptions) {
    debugMode && console.log('OLDEST APPLICANT IS MINOR');
    planOptions.programs[0].programLevels.forEach(function (plan) {
      plan.healthyDiscountTotalAmount = 'N/A';
    });
    return planOptions;
  };
  /********************************************/
  /// CHECK IF PLANS CAN BE FETCHED function ///

  /********************************************/


  var checkIfPlansCanBeFetched = function checkIfPlansCanBeFetched() {
    debugMode && console.log('Validating inputs'); // Check if we are currently fetching prices

    if (isFetchingPlans) return setPlansCanBeFetched(false);
    if (!verified.coverageID) return setPlansCanBeFetched(false);
    if (!verified.birthday) return setPlansCanBeFetched(false);
    if (!verified.maritalStatus) return setPlansCanBeFetched(false);
    if (!verified.state) return setPlansCanBeFetched(false);
    debugMode && console.log('INPUTS VALID');
    return setPlansCanBeFetched(true);
  };
  /*********************/
  /// RETURN function ///

  /*********************/


  return /*#__PURE__*/React.createElement("div", {
    className: "ccm-pricing-calculator-classic",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 266,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("form", {
    className: "share-calculator-classic",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 267,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: 'question-classic',
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 268,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("label", {
    className: "pricing-calculator-label-classic " + (props.greenLabels ? 'green-labels-classic' : 'default-labels-classic'),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 269,
      columnNumber: 11
    }
  }, "How many people are applying? *"), /*#__PURE__*/React.createElement("select", {
    className: 'pricing-calculator-select-classic',
    name: "number-of-people",
    value: coverageID,
    onChange: function onChange(e) {
      return updateCoverageID(parseInt(e.target.value));
    },
    required: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 270,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement("option", {
    disabled: true,
    value: '--Select--',
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 279,
      columnNumber: 13
    }
  }, "--Select--"), /*#__PURE__*/React.createElement("option", {
    value: 1,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 280,
      columnNumber: 13
    }
  }, "One"), /*#__PURE__*/React.createElement("option", {
    value: 2,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 281,
      columnNumber: 13
    }
  }, "Two"), /*#__PURE__*/React.createElement("option", {
    value: 3,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 282,
      columnNumber: 13
    }
  }, "Three or more"))), /*#__PURE__*/React.createElement("div", {
    className: 'question-classic',
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 286,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("label", {
    className: "pricing-calculator-label-classic " + (props.greenLabels ? 'green-labels-classic' : 'default-labels-classic'),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 287,
      columnNumber: 11
    }
  }, "Date of birth of oldest person applying *"), /*#__PURE__*/React.createElement(NumberFormat, {
    name: 'birthday',
    className: 'birthday-input-classic',
    value: birthday,
    placeholder: "MM/DD/YYYY",
    format: "##/##/####",
    mask: "_",
    onValueChange: function onValueChange(change) {
      return updateBirthday(change.formattedValue);
    },
    onBlur: function onBlur() {
      return validateBirthday();
    },
    style: {
      border: verified.birthday === false ? "2px solid red" : ""
    },
    required: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 288,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: 'question-classic',
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 304,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("label", {
    className: "pricing-calculator-label-classic " + (props.greenLabels ? 'green-labels-classic' : 'default-labels-classic'),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 305,
      columnNumber: 11
    }
  }, "Marital Status *"), /*#__PURE__*/React.createElement("select", {
    className: 'pricing-calculator-select-classic',
    selected: maritalStatus,
    value: maritalStatus,
    onChange: function onChange(e) {
      return updateMaritalStatus(e.target.value);
    },
    onBlur: function onBlur() {
      return validateMaritalStatus();
    },
    style: {
      borderRadius: verified.maritalStatus === false ? "state-input-invalid" : "",
      generalInputStyle: 'pricing-calculator-state-input-classic'
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 306,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement("option", {
    disabled: true,
    value: '--Select--',
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 317,
      columnNumber: 13
    }
  }, "--Select--"), /*#__PURE__*/React.createElement("option", {
    value: "single",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 318,
      columnNumber: 13
    }
  }, "Single"), /*#__PURE__*/React.createElement("option", {
    value: "married",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 319,
      columnNumber: 13
    }
  }, "Married"), /*#__PURE__*/React.createElement("option", {
    value: "divorced",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 320,
      columnNumber: 13
    }
  }, "Divorced"), /*#__PURE__*/React.createElement("option", {
    value: "widowed",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 321,
      columnNumber: 13
    }
  }, "Widowed"))), /*#__PURE__*/React.createElement("div", {
    className: "question-classic state-field-classic",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 325,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(StatePicker, {
    selectedState: state,
    onStateSelected: function onStateSelected(state) {
      return updateState(state);
    },
    onBlur: function onBlur() {
      return validateState();
    },
    muleApiUrl: props.muleApiUrl,
    muleClientId: props.muleClientId,
    muleClientSecret: props.muleClientSecret,
    defaultOptionText: "--Select--",
    showFullStateNames: props.showFullStateNames,
    statesOverride: props.statesOverride,
    onStatesFetched: props.onStatesFetched,
    style: {
      generalInputStyle: 'pricing-calculator-state-input-classic',
      titleStyle: "pricing-calculator-label-classic " + (props.greenLabels ? 'green-labels-classic' : 'default-labels-classic')
    },
    showRequiredAsterisk: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 326,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick(e) {
      return handleFetchPrices(e);
    },
    className: "pricing-form-button-classic",
    disabled: !plansCanBeFetched,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 345,
      columnNumber: 9
    }
  }, "SEE SHARE AMOUNTS NOW")));
};

PricingCalculatorClassic.defaultProps = {
  debugMode: false,
  statesOverride: null,
  showFullStateNames: false,
  hideStateDefaultText: false,
  greenLabels: false
};
PricingCalculatorClassic.propTypes = process.env.NODE_ENV !== "production" ? {
  auth: PropTypes.string.isRequired,
  onPlanOptionsRequested: PropTypes.func.isRequired,
  onPlanOptionsFetched: PropTypes.func.isRequired,
  debugMode: PropTypes.bool,
  showFullStateNames: PropTypes.bool,
  statesOverride: PropTypes.array,
  onStatesFetched: PropTypes.func,
  hideStateDefaultText: PropTypes.bool,
  greenLabels: PropTypes.bool
} : {};
export default PricingCalculatorClassic;